import React from 'react';

const MainTabPanel = ({ active, children }) => {
  if (!active) {
    return null;
  }

  return (
    <section className="tab-content active">
      <div className="inner">{children}</div>
    </section>
  );
};

export default MainTabPanel;
